<template>
<LayoutContainer columns="30/70">
<v-toolbar slot="header" dark class="primary no-print">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>home</v-icon>
    </v-btn>
    <v-toolbar-title>{{pageTitle}}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu bottom left :nudge-width="200">
        <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" dark>
            <v-icon>more_vert</v-icon>
        </v-btn>
        </template>
        <v-list>            
            <v-list-item> 
                <v-list-item-title>Do Something</v-list-item-title>
            </v-list-item>            
        </v-list>
    </v-menu>
    
</v-toolbar>

<!-- ******************  Left Column ****************************** -->
 
<div slot="col1" class="no-print">
    <AdvancedList :items="templates" :data-ref="listRef" @click="selectTemplate" />
</div> 

<!-- ******************  Right Column ****************************** -->

<div slot="col2" >
    <template v-if="checklistKey">
        <AdvancedPanel class="no-print" :fields="templateDetailsPanel.fields" :record="templateDetails" :recordRef="listItemRef" :settings="templateDetailsPanel.settings"    
            @button="templateDetailsButton"
            @field-change="templateDetailsFieldChanged"
        />     
        <ChecklistDetails ref="templateDetails" :checklistKey="checklistKey" mode="Template" />
    </template>
    <template v-else>
        <NoRecordsPlaceholder message="Select a Template"/>
    </template>
</div>

<!--Dialog-->

<template slot="dialogs">
        
    <AdvancedDialog :record="addDocumentDialog.record" :settings="addDocumentDialog.settings" :fields="addDocumentDialog.fields" @save="saveDocumentForCategory" />

</template>


</LayoutContainer>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'
import StringHelpers from '../../helpers/StringHelpers'
import DataHelpers from '../../helpers/DataHelpers'
import AlertHelpers from '@/helpers/AlertHelpers'
import NiceData from '../../data/NiceData'
import ChecklistDetails from './ChecklistDetails'
import ChecklistHelpers from './ChecklistHelpers'
import AdvancedList from '../../ui-elements/AdvancedList'
import AdvancedPanel from '../../ui-elements/AdvancedPanel'
import AdvancedDialog from '../../ui-elements/AdvancedDialog'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'

export default {
    name: 'ChecklistTemplates',
    props: {
            tenantKey: String,
            transactionKey: String,
            checklistKey: String
    }, 

    components: {
        LayoutContainer,
        ChecklistDetails,
        AdvancedList,
        AdvancedPanel,
        AdvancedDialog,
        NoRecordsPlaceholder,
    },
    data() {
        return {
            templates: [],
            templateDetails: {},
      //      search: '',


            checklistTable: {
                ref: null,
                fields: [
                    {name: 'name', type: 'Text'},
                    {name: 'templates', type: 'List'},
                    {name: 'template', type: 'Switch',},
                    {name: 'global', type: 'Switch'},
                    {name: 'stamp', type: 'Text', default: '[stamp]'},
                    {name: 'tenantKey', type: 'Text', default: '[tenantKey]'},
                ],
            },

            templateDetailsPanel: {
                fields: [
                    {name: 'name', title: 'Template Name', type: 'Text'},
                    {name: 'advanced', title: 'Show Advanced Options', type: 'Switch', width:70},
                    {name: 'done', title: 'Done', type: 'Button', width:30},
                    {name: 'template', title: 'Template', type: 'Switch', visibleFilter: '[advanced] = true', disabled:true},
                    {name: 'global', title: 'Global', type: 'Switch', visibleFilter: '[template] = true && [advanced] = true'},
                    {name: 'makeCopy', title: 'Make a Copy', type: 'Button', visibleFilter: '[advanced] = true', width:50},
                    {name: 'deleteTemplate', title: 'Delete Template', type: 'Button', color:'error', visibleFilter: '[advanced] = true', width:50},
                ],
                settings: {},
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: [], 
            },

            addDocumentFields: [
                {name: 'name', title: 'Name', type: 'Text', focus: true},
                {name: 'checks', title: 'Things to Check', type: 'Group', fields: [
                    {name: 'check', title: 'Please Check', type: 'Text', width:70},
                ]},
            ],
            
        }
    },
     
    computed: {

        topRef() {
            return DataHelpers.getRootRef().child('app/documentChecklist')
        },
        listRef() {
            return this.topRef.child('list')
        },
        listItemRef() {
            return this.listRef.child(this.checklistKey)
        },
        dataRef() {
            return this.topRef.child('data').child(this.checklistKey)
        },
        pageTitle() {
            return this.templateDetails.name || 'Document Checklist Templates'
        }

    },  
    methods: {
        goToTemplate(key) {
            this.$router.push('/' + this.tenantKey + '/checklist-templates/' + key)
        },

        selectTemplate(template) {
            this.goToTemplate(template.meta.key)
        },

        async templateDetailsButton(buttonName, record) {
            if(buttonName == 'makeCopy') {
                let newKey = DataHelpers.getKey()
                NiceData.copyItems(this.dataRef.child('categories'), this.topRef.child('data').child(newKey).child('categories'))
                NiceData.copyItems(this.dataRef.child('policies'), this.topRef.child('data').child(newKey).child('policies'))
                NiceData.copyItems(this.dataRef.child('options'), this.topRef.child('data').child(newKey).child('options'))
                NiceData.copyItems(this.dataRef.child('documents'), this.topRef.child('data').child(newKey).child('documents'))
                
                let newDetails = {...this.templateDetails}
                newDetails.name += ' (copy)'
                newDetails.tenantKey = this.tenantKey
                newDetails.global = false
                newDetails.advanced = null
                
                newDetails.meta.key = newKey
                NiceData.saveItem(newDetails)
                this.goToTemplate(newKey)
            }

            if(buttonName == 'deleteTemplate') {
                if(await this.$root.$confirm('Delete', 'Delete this entire template?', { color: 'red' }) == true) {

                    ChecklistHelpers.deleteChecklist(record.meta.key)
                    this.loadTemplates()
                    this.$router.push('/' + this.tenantKey + '/checklist-templates')
                }
            }

        },


        templateDetailsFieldChanged(changes) {

        },

        categoryClicked(category) {
            let categoryName = category.name
        },

        addDocumentForCategory(categoryName) {
            console.log('addDocumentForCategory', categoryName)
            this.addDocumentDialog.fields = this.addDocumentFields
            this.addDocumentDialog.record = {}
            this.addDocumentDialog.settings.visible = true
        },

        saveDocumentForCategory(document) {
            console.log('saveDocumentForCategory', document)
        },
        
        


      
        
        loadDetails() {
            this.checklistTable.ref = DataHelpers.getRootRef().child('app/documentChecklist/list')
            let ref = this.checklistTable.ref.child(this.checklistKey)

            NiceData.fetchItemSingle(ref).then( (item) => {
                if(item)
                    this.templateDetails = item
                else {
                    this.templateDetails = NiceData.makeRecord(this.checklistTable)
                    this.templateDetails.meta.key = this.checklistKey
                    NiceData.saveItem(this.templateDetails)
                }
            })
        
        },

        loadTemplates() {
            let templatesRef = DataHelpers.getRootRef().child('app/documentChecklist/list').orderByChild('template').equalTo(true)
            templatesRef.on('value', snap => {
                  this.templates = NiceData.arrayFromSnapshot(snap).filter(o => {
                    return o.global == true || (o.tenantKey == this.tenantKey && o.template)
                })
            })
    
        },

        loadTemplateData() {
            this.loadDetails()

        }
    },

    watch: {
        'checklistKey': {
            handler: function(newVal, oldVal) {
                if(newVal)
                    this.loadTemplateData()
            },
            immediate: true
        }

    },

    created () {

            DataHelpers.initialiseTenant(this.tenantKey)
            this.loadTemplates()
    }
}

</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// ChecklistTemplates.vue?549e80f4